import Quill from "quill"
import QuillImageDropAndPaste from "quill-image-drop-and-paste"

// This class extends the QuillImageDropAndPaste module
// to handle non-image files.
// For those, it calls `option.nonImageHandler`
class ExtendedQuillImageDropAndPaste extends QuillImageDropAndPaste {
  handleDrop(e) {
    if (!e.dataTransfer || !e.dataTransfer.files) return
    this.handleNonImages(e.dataTransfer.files)
    super.handleDrop(e)
  }

  handlePaste(e) {
    if (!e.clipboardData || !e.clipboardData.items) return
    this.handleNonImages(e.clipboardData.items)
    super.handlePaste(e)
  }

  handleNonImages(files) {
    if (!this.option.nonImageHandler) return
    const nonImageFiles = Array.prototype.filter.call(
      files,
      (file) => !file.type.startsWith("image"),
    )
    if (nonImageFiles.length == 0) return

    this.option.nonImageHandler(nonImageFiles)
  }
}
Quill.register("modules/imageDropAndPaste", ExtendedQuillImageDropAndPaste)
